import { Injectable } from "@angular/core";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

// multi-asset
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { ATDLUtilityService } from "./atdl-utility.service";

@Injectable()
export class ATDLComparatorService {
  /**********************************************************************/
  /* CONSTRUCTOR  */

  constructor(protected utility: ATDLUtilityService) {}

  /**********************************************************************/
  /* PUBLIC  */

  public lessThan(value1: any, value2: any, stringAsNumber: boolean = false): boolean {
    // handle big number
    if (value1 instanceof CubiqTS.BigNumber) {
      value1 = value1.toString();
      stringAsNumber = true;
    }
    if (stringAsNumber && (value2 instanceof CubiqTS.BigNumber || typeof value2 === "number")) {
      value2 = value2.toString(); // toString is the same for big number and number
    }

    if (!isNaN(value1) && !isNaN(value2)) {
      stringAsNumber = true;
    }

    if (value1 == null || value2 == null) {
      return false;
    } else if (
      value1 instanceof Array &&
      (value2 instanceof Array || (value2 != null && value2 != "" && !isNaN(value2)))
    ) {
      // ARRAY Comparison
      return this.arrayLessThan(value1, value2);
    } else if (typeof value1 === "number" && typeof value2 === "number") {
      return this.numberLessThan(value1, value2);
    } else if (typeof value1 === "string" && typeof value2 === "string" && stringAsNumber) {
      return this.numberLessThan(value1, value2);
    } else if (typeof value1 === "string" && value2 != null && value2 != "" && !isNaN(value2)) {
      return this.stringLengthLessThan(value1, value2);
    } else {
      logger.out.error(
        `ERROR: ATDLComparator.lessThan(): Proper comparator could not be determined!`,
      );
      return false;
    }
  }

  public greaterThan(value1: any, value2: any, stringAsNumber: boolean = false): boolean {
    // handle BigNumber
    if (value1 instanceof CubiqTS.BigNumber) {
      value1 = value1.toString();
      stringAsNumber = true;
    }
    if (stringAsNumber && (value2 instanceof CubiqTS.BigNumber || typeof value2 === "number")) {
      value2 = value2.toString(); // toString is the same for big number and number
    }

    if (!isNaN(value1) && !isNaN(value2)) {
      stringAsNumber = true;
    }

    if (value1 == null || value2 == null) {
      return false;
    } else if (
      value1 instanceof Array &&
      (value2 instanceof Array || (value2 != null && value2 != "" && !isNaN(value2)))
    ) {
      // ARRAY Comparison
      return this.arrayGreaterThan(value1, value2);
    } else if (typeof value1 === "number" && typeof value2 === "number") {
      return this.numberGreaterThan(value1, value2);
    } else if (typeof value1 === "string" && typeof value2 === "string" && stringAsNumber) {
      return this.numberGreaterThan(value1, value2);
    } else if (typeof value1 === "string" && value2 != null && value2 != "" && !isNaN(value2)) {
      return this.stringLengthGreaterThan(value1, value2);
    } else {
      logger.out.error(
        `ERROR: ATDLComparator.lessThan(): Proper comparator could not be determined!`,
      );
      return false;
    }
  }

  /**
   * Defines lessThanEquals in terms of greaterTHan
   * @param value1
   * @param value2
   * @return
   *
   */
  public lessThanEquals(value1: any, value2: any, stringAsNumber: boolean = false): boolean {
    // handle BigNumber
    if (value1 instanceof CubiqTS.BigNumber) {
      value1 = value1.toString();
      stringAsNumber = true;
    }
    if (stringAsNumber && (value2 instanceof CubiqTS.BigNumber || typeof value2 === "number")) {
      value2 = value2.toString(); // toString is the same for big number and number
    }

    if (!isNaN(value1) && !isNaN(value2)) {
      stringAsNumber = true;
    }

    if (value1 == null || value2 == null) {
      return false;
    } else if (
      value1 instanceof Array &&
      (value2 instanceof Array || (value2 != null && value2 != "" && !isNaN(value2)))
    ) {
      // ARRAY Comparison
      return !this.arrayGreaterThan(value1, value2);
    } else if (typeof value1 === "number" && typeof value2 === "number") {
      return !this.numberGreaterThan(value1, value2);
    } else if (typeof value1 === "string" && typeof value2 === "string" && stringAsNumber) {
      return !this.numberGreaterThan(value1, value2);
    } else if (typeof value1 === "string" && value2 != null && value2 != "" && !isNaN(value2)) {
      return !this.stringLengthGreaterThan(value1, value2);
    } else {
      logger.out.error(
        `ERROR: ATDLComparator.lessThanEquals(): Proper comparator could not be determined!`,
      );
      return false;
    }
  }

  /**
   * Defines greaterThanEquals in terms of lessThan
   *
   * @param value1
   * @param value2
   * @return
   *
   */
  public greaterThanEquals(value1: any, value2: any, stringAsNumber: boolean = false): boolean {
    // handle BigNumber
    if (value1 instanceof CubiqTS.BigNumber) {
      value1 = value1.toString();
      stringAsNumber = true;
    }
    if (stringAsNumber && (value2 instanceof CubiqTS.BigNumber || typeof value2 === "number")) {
      value2 = value2.toString(); // toString is the same for big number and number
    }

    if (!isNaN(value1) && !isNaN(value2)) {
      stringAsNumber = true;
    }

    if (value1 == null || value2 == null) {
      return false;
    } else if (
      value1 instanceof Array &&
      (value2 instanceof Array || (value2 != null && value2 != "" && !isNaN(value2)))
    ) {
      // ARRAY Comparison  && value2 instanceof Array
      return !this.arrayLessThan(value1, value2);
    } else if (typeof value1 === "number" && typeof value2 === "number") {
      return !this.numberLessThan(value1, value2);
    } else if (typeof value1 === "string" && typeof value2 === "string" && stringAsNumber) {
      return !this.numberLessThan(value1, value2);
    } else if (typeof value1 === "string" && value2 != null && value2 != "" && !isNaN(value2)) {
      return !this.stringLengthLessThan(value1, value2);
    } else {
      logger.out.error(
        `ERROR: ATDLComparator.lessThanEquals(): Proper comparator could not be determined!`,
      );
      return false;
    }
  }

  public equals(value1: any, value2: any, stringAsNumber: boolean = false): boolean {
    // handle BigNumber
    if (value1 instanceof CubiqTS.BigNumber) {
      value1 = value1.toString();
      stringAsNumber = true;
    }
    if (stringAsNumber && (value2 instanceof CubiqTS.BigNumber || typeof value2 === "number")) {
      value2 = value2.toString(); // toString is the same for big number and number
    }

    if (!isNaN(value1) && !isNaN(value2)) {
      stringAsNumber = true;
    }

    if ((value1 === null && value2 === null) || (value1 === undefined && value2 === undefined)) {
      return true;
    } else if ((value1 == null && value2 != null) || (value1 != null && value2 == null)) {
      return false;
    } else if (typeof value1 === "boolean" && typeof value2 === "boolean") {
      return value1 === value2;
    } else if (
      (typeof value1 === "boolean" && typeof value2 === "string") ||
      (typeof value1 === "string" && typeof value2 === "boolean")
    ) {
      if (typeof value1 === "string" && (value1 === "true" || value1 === "false")) {
        let value1Boolean: boolean = value1 === "true";
        return value1Boolean === value2;
      } else if (typeof value2 === "string" && (value2 === "true" || value2 === "false")) {
        let value2Boolean = value2 === "true";
        return value1 === value2Boolean;
      } else {
        return false;
      }
    } else if (
      (typeof value1 === "string" || typeof value1 === "number") &&
      (typeof value2 === "string" || typeof value2 === "number") &&
      stringAsNumber
    ) {
      if (typeof value1 !== typeof value2) {
        if (typeof value1 === "number") {
          value1 = value1.toFixed(10);
        }
        if (typeof value2 === "number") {
          value2 = value2.toFixed(10);
        }
      }
      return value1 === value2;
    } else if (typeof value1 === "string" && value2 != null && value2 != "" && !isNaN(value2)) {
      return value1.length === Number(value2);
    } else if (typeof value1 === "string" && typeof value2 === "string") {
      return value1 === value2;
    } else if (value1 instanceof Object && value2 instanceof Object) {
      return this.utility.equals(value1, value2);
    } else {
      return false;
    }
  }

  /************************************************************************************************/

  /**
   * Is the first argument less than the second argument?
   *
   * @param value1
   * @param value2
   * @return <code>true</code> if first argument is less than second
   *
   */
  private arrayLessThan(value1: Array<any>, value2: any, equals: boolean = false): boolean {
    let length1: number = (value1 as Array<any>).length;
    let length2: number;
    if (value2 instanceof Array) {
      length2 = (value2 as Array<any>).length;
    } else if (typeof value2 === "number") {
      length2 = value2;
    } else if (!isNaN(value2) && typeof value2 === "string") {
      length2 = Number(value2); //value2.indexOf('.') > 0 ? parseFloat(value2) :parseInt(value2, 10);
    } else {
      return false;
    }

    return equals ? length1 <= length2 : length1 < length2;
  }

  /**
   * Is the first argument greater than the second argument?
   *
   * @param value1
   * @param value2
   * @return <code>true</code> if first argument is less than second
   *
   */
  private arrayGreaterThan(value1: Array<any>, value2: any, equals: boolean = false): boolean {
    let length1: number = (value1 as Array<any>).length;
    let length2: number;
    if (value2 instanceof Array) {
      length2 = (value2 as Array<any>).length;
    } else if (typeof value2 === "number") {
      length2 = value2;
    } else if (!isNaN(value2) && typeof value2 === "string") {
      length2 = Number(value2); //value2.indexOf('.') > 0 ? parseFloat(value2) :parseInt(value2, 10);
    } else {
      return false;
    }
    return equals ? length1 >= length2 : length1 > length2;
  }

  /**
   * Is the first argument less than the second argument?
   *
   * @param value1
   * @param value2
   * @return <code>true</code> if first argument is less than second
   *
   */
  private numberLessThan(
    value1: number | string,
    value2: number | string,
    equals: boolean = false,
  ): boolean {
    let number1: number =
      typeof value1 === "number" ? value1 : typeof value1 === "string" ? parseFloat(value1) : null;
    let number2: number =
      typeof value2 === "number" ? value2 : typeof value2 === "string" ? parseFloat(value2) : null;
    return !isNaN(number1) && !isNaN(number2)
      ? equals
        ? number1 <= number2
        : number1 < number2
      : false;
  }

  /**
   * Is the first argument greater than the second argument?
   *
   * @param value1
   * @param value2
   * @return <code>true</code> if first argument is less than second
   *
   */
  private numberGreaterThan(
    value1: number | string,
    value2: number | string,
    equals: boolean = false,
  ): boolean {
    let number1: number =
      typeof value1 === "number" ? value1 : typeof value1 === "string" ? parseFloat(value1) : null;
    let number2: number =
      typeof value2 === "number" ? value2 : typeof value2 === "string" ? parseFloat(value2) : null;
    return !isNaN(number1) && !isNaN(number2)
      ? equals
        ? number1 >= number2
        : number1 > number2
      : false;
  }

  /**
   * Is the first argument less than the second argument?
   *
   * @param value1
   * @param value2 - int value of length
   * @return <code>true</code> if first argument is less than second
   *
   */
  private stringLengthLessThan(
    value1: string,
    value2: number | string,
    equals: boolean = false,
  ): boolean {
    let length1: number = typeof value1 === "string" ? value1.length : null;
    let length2: number =
      typeof value2 === "number"
        ? value2
        : typeof value2 === "string"
        ? parseInt(value2, 10)
        : null;
    return !isNaN(length1) && !isNaN(length2)
      ? equals
        ? length1 <= length2
        : length1 < length2
      : false;
  }

  /**
   * Is the first argument greater than the second argument?
   *
   * @param value1
   * @param value2
   * @return <code>true</code> if first argument is less than second
   *
   */
  private stringLengthGreaterThan(
    value1: string,
    value2: number | string,
    equals: boolean = false,
  ): boolean {
    let length1: number = typeof value1 === "string" ? value1.length : null;
    let length2: number =
      typeof value2 === "number"
        ? value2
        : typeof value2 === "string"
        ? parseInt(value2, 10)
        : null;
    return !isNaN(length1) && !isNaN(length2)
      ? equals
        ? length1 >= length2
        : length1 > length2
      : false;
  }
}
